const SessionTimeoutComponent = {
    templateUrl: '/sessionTimeout/sessionTimeout.tpl.html',
    controller: 'sessionTimeoutController',
    bindings: {}
};

angular.module('umCore')
    .component('sessionTimeout', SessionTimeoutComponent);
